// LIBS
import React from 'react'
import {Helmet} from 'react-helmet'
import {renderIf, getOr} from '../../lib/util.js'
import {get, union} from 'lodash/fp'

// DEFAULTS
const defaultDescription = 'Code Fellows is an in-person coding school, training software developers in advanced programming in Python, ASP.NET, Java, and Full-Stack JavaScript.'
const defaultImage = 'https://images.ctfassets.net/k428n7s2pxlu/4idE4SIBKMeyyY6usOGk0q/fa2f4f68091388f0a434df5396872a72/cf-open-graph-image-default.jpg'
const defaultKeywords = [
  'Code Fellows',
  'code school',
  'coding school',
  'coding bootcamp',
  'Seattle coding school',
  'Seattle coding bootcamp',
  'computer coding classes Seattle',
]

// INTERFACE
// this is used within Helmet and helmet does not allow for nested compoennts
// so this returns an array (and all iterators need unique key props in react)
// useage is {MetaData(data)} dont use <MetaData data={data} /> it wont work
export default ({data, children}) => {
  let title = (data.title || 'Code Fellows').trim() + ' - Learn to Code | Code Fellows'
  let description = getOr(['metaDescription', 'description'], data) || defaultDescription
  let twitterAuthor = get('author.fields.twitter', data) || '@codefellows'
  let image = getOr([ 'imageHeader.fields.file.url', 'image.fields.file.url'], data) || defaultImage
  image = image.startsWith('//') ? 'https:' + image : image
  let canonicalUrl = 'https://www.codefellows.org/' + (data.slug ? data.slug + '/' : '' )
  let keywords = union(defaultKeywords, data.keywords).join(',')

  return (
    <Helmet itemScope itemType="http://schema.org/WebPage">
      {/* GENERAL */}
      <meta  charSet="utf-8" />
      <title itemProp='headline'>{title}</title>
      <link itemProp='sameAs' rel="canonical" href={canonicalUrl} />
      <meta itemProp='description' name='description' content={description} />
      <meta itemProp='keywords' name='keywords' content={keywords} />

      {/* OPEN GRPAH*/}
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Code Fellows" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* FACEBOOK */}
      <meta property="fb:admins" content="379865715439924" />

      {/* TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@codefellows" />
      <meta name="twitter:creator" content={twitterAuthor} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {renderIf(children, children)}
    </Helmet>
  )
}



// WEBPACK FOOTER //
// ./src/components/meta-data/index.js